// Hằng số cân bằng: nguồn DUY NHẤT (BALANCE.md §11). Mỗi milestone chỉ thêm phần mình dùng.
// Không khai báo lại các hằng số này ở chỗ khác (npm run lint:data kiểm).
export const BALANCE = {
  // Thọ nguyên tối đa theo chỉ số cảnh giới gốc 0 (BALANCE §1.5)
  LIFESPAN_BY_REALM: [120, 200, 500, 1000, 2000, 5000, 10000, 30000, 99999],
  START_AGE: 16,
  LIFESPAN_FLOOR_RATIO: 0.05,
  // Tam Nguyên: điểm mỗi bước tiểu cảnh, chia theo tỉ lệ công pháp chủ tu (BALANCE §1.2)
  TRI_ORIGIN_PER_STEP: 3,

  // ── Tu luyện (BALANCE §2)
  CULT_COST_BASE: 9_000,
  CULT_COST_STEP_GROWTH: 1.15,
  CULT_COST_REALM_GROWTH: 8,
  CULT_COST_LK_SCALE: 1 / 45,
  // Nồng độ linh khí: B_vùng theo realmIdx của vùng × phẩm linh mạch × M (WORLD §3.1)
  ZONE_BASE_DENSITY: [1.25, 1.25, 1.25, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8],
  VEIN_GRADE_MULT: { none: 0.6, low: 1.0, mid: 1.3, high: 1.7, peak: 2.2 },
  OUTER_SEAT_MULT: 0.8,
  SITE_TIER_PENALTY_GAP: 2,
  SITE_TIER_PENALTY_MULT: 0.5,
  // Sự kiện "linh mạch khô" của Thanh Hư Linh Mạch từ LK5 (WORLD §6.2)
  VEIN_DRY_MULT: 0.7,
  QI_RATE_BASE: 1,
  QI_RATE_REALM_GROWTH: 6,
  LAMP_ROOT_BASE: 1.0,
  LAMP_ROOT_PER_REALM: 0.1,
  LAMP_ROOT_MIN: 0.8,
  TECHNIQUE_GRADE_MULT: { hoang: 1.0, huyen: 1.25, dia: 1.5, thien: 2.0, tien: 2.5 },
  TECHNIQUE_LAYER_BONUS: 0.08,
  TECHNIQUE_ELEMENT_MATCH_BONUS: 0.1,
  TECHNIQUE_LAYER_MASTERY_COST: [0, 30, 120, 400, 1200, 3200, 8000, 18000, 40000],
  TECHNIQUE_LAYER_STONE_COST: [0, 50, 150, 450, 1350, 4050, 12150, 36450, 109350],
  TECHNIQUE_LAYER_CAP_BY_REALM: [3, 4, 5, 6, 7, 8, 9, 9, 9],
  GATHER_ARRAY_QI_PER_LV: 0.1,
  BUFF_BUCKET_CAP: 1.5,
  OFFLINE_EFF_BASE: 0.6,
  OFFLINE_EFF_PER_ARRAY_LV: 0.025,
  OFFLINE_EFF_CAP: 0.85,
  OFFLINE_CAP_HOURS: 72,
  OFFLINE_BLOCK_HOURS: 8,
  ONLINE_EFF: 1,
  MASTERY_PER_MIN: 2,
  OVERFLOW_QI_CAP_RATIO: 0.25,
  DEATH_SECLUSION_MULT: 3,
  DEATH_SECLUSION_DURATIONS_H: [4, 8, 24, 72],
  DEATH_SECLUSION_LIFESPAN_RATIO_PER_H: 1 / 300,
  // Log idle hiếm: kỳ vọng số dòng lạ mỗi tuần vắng (CULTIVATION §1.4: ≤ 1/tuần)
  IDLE_RARE_LINES_PER_WEEK: 1,
  // Hồi Sơn: vắng từ 1 canh giờ (2h) trở lên (UI_SPEC §16)
  RETURN_SUMMARY_MIN_HOURS: 2,

  // ── Kinh tế (BALANCE §6)
  NEWBIE_QUEST_STONES: 500,

  // ── Chỉ số người chơi & Lực Chiến (BALANCE §1.2, §1.3) — M2
  HP_STD: 100,
  ATK_STD: 10,
  PLAYER_STAT_MULT: 4,
  PLAYER_DEF_BASE: 20,
  CRIT_RATE_BASE: 0.05,
  CRIT_DMG_BASE: 1.5,
  LC_SCALE: 100,
  LC_DEF_REF: 20,
  // Tam Nguyên → chỉ số mỗi điểm (BALANCE §1.2): Thể +1,5% HP +0,2 DEF · Linh +1,5% ATK · Thần +1% ATK
  TRI_STAT: { bodyHpPct: 0.015, bodyDef: 0.2, spiritAtkPct: 0.015, mindAtkPct: 0.01 },
  // Scaling vũ khí S–E (BALANCE §1.2) và % ATK vũ khí mỗi điểm × hệ số (ITEMS §3.3)
  WEAPON_SCALE_COEF: { S: 1.6, A: 1.3, B: 1.0, C: 0.75, D: 0.5, E: 0.25 },
  WEAPON_SCALE_PER_POINT: 0.006,
  // Hệ số dòng chính theo ô: chỉ số gốc = K × P(Giai) (ITEMS §3.7; K chốt ở M2, DECISIONS)
  ITEM_MAIN_K: {
    weapon: { atk: 0.96 },
    helm: { hp: 3.2, mana: 1.6 },
    robe: { hp: 4.8, def: 4 },
    pants: { hp: 4.0, def: 3 },
    gloves: { atk: 0.32, def: 2 },
    boots: { def: 3, hp: 1.6 },
    necklace: { mana: 2.4, atk: 0.24 },
    ring: { atk: 0.24, hp: 0.96 },
    treasure: { atk: 0.48, hp: 2.4 },
  },
  ITEM_GIAI_PHU_STEP: 0.04,
  TRI_LINE_GIAI_DIV: 10,
  GEAR_OFFLINE_EFF_CAP_PTS: 5,
  ENHANCE_STEP: 0.05,

  // ── Loot (BALANCE §5, ITEMS §3.4–3.5, §8)
  ZONE_DENSITY_BY_REALM: [4, 5, 6, 7, 7, 7, 7, 7, 7],
  TRAVEL_S: 2,
  ZONE_QI_MUL_DEFAULT: 0.1,
  // R1 tu vi phụ mỗi lần hạ = SIDE_QI_PER_P × P quái × zone.qiMul × thưởng màu (BALANCE §5.1)
  SIDE_QI_PER_P: 0.6,
  STONE_PER_KILL: 1,
  ROLL: { qi: 1.0, material: 0.6, equip: 0.12, dust: 0.35 },
  ROLL_MATERIAL_TIER_B: 0.05,
  ROLL_DUST_SHARD_SHARE: 0.25,
  // R4: Bụi 1–3 mỗi lần trúng (BALANCE §5.1)
  ROLL_DUST_AMOUNT: [1, 3],
  // Màu cấp theo ΔL = L quái − L người chơi (BALANCE §1.4): ΔL ≤ ngưỡng → màu; vượt đỏ hay Δlog ≥ 1 → đầu lâu
  LEVEL_COLOR_MAX_DL: { grey: -5, green: -2, yellow: 1, orange: 2, red: 3 },
  LEVEL_COLOR_REWARD: { grey: 0, green: 0.7, yellow: 1, orange: 1.2, red: 1.4, skull: 1.4 },
  IDLE_EQUIP_RARITY: { mortal: 70, yellow: 25, mystic: 5 },
  TRIAL_QI_SHARE: 0.3,
  MASTERY_TRIAL_SHARE: 0.3,
  DPS_MODEL: { hitsPerS: 1.25, avgCoef: 1.5, crit: 1.03, partyMult: 1.5 },
  AUTO_EFF: 0.75,
  AFFIX_TIER_WEIGHTS: { common: [30, 28, 22, 14, 6], elite: [24, 28, 24, 16, 8], boss: [18, 26, 26, 20, 10] },
  AFFIX_ROLL_NOTCHES: 20,
  AFFIX_ROLE_WEIGHT: 3,
  // Loot cá nhân: dòng khớp Tam Nguyên trội của vũ khí đang dùng ×1,5 (ITEMS §4, §7.5; chưa áp ở P0, DECISIONS)
  LOOT_AFFIX_TRI_MULT: 1.5,
  // Đạo Văn trên món rơi ra: cấp 2 với xác suất này, còn lại cấp 1 (ITEMS §5.1)
  GLYPH_DROP_LEVEL2_CHANCE: 0.2,
  // Chuyển cấp cường hóa sang món mới cùng ô: giữ 80% (làm tròn xuống) (ITEMS §8.1)
  ENHANCE_TRANSFER_KEEP: 0.8,
  // Giá thu linh dược ở Phường Thị theo niên phân = giá thập niên × hệ số (DECISIONS M2)
  HERB_AGE_SELL_MULT: { decade: 1, century: 3, millennium: 10, myriad: 30 },
  LOOT_SLOT_FOCUS_MULT: 1.5,
  LOOT_WEAPON_SAME_TYPE: 0.6,
  RARITY_DUST: { mortal: 1, yellow: 3, mystic: 8, earth: 20, heaven: 60, immortal: 200, chaos: 400 },
  SALVAGE_REFINING_STONE: { earth: 1, heaven: 2, immortal: 5, chaos: 10 },
  ENHANCE_MAX: 10,
  ENHANCE_SUCCESS: [1, 1, 1, 1, 0.9, 0.8, 0.65, 0.5, 0.4, 0.3],
  ENHANCE_STONES: [1, 2, 3, 4, 6, 8, 12, 16, 22, 30],
  ENHANCE_SPIRIT_STONE_PER_LV: 20,
  ENHANCE_FAIL_BONUS: 0.1,
  UPGRADE_MIN_LC_GAIN: 0.02,
  UPGRADE_FLASH_LC_GAIN: 0.1,
  BAG_CAPACITY: 36,
  // Trữ Lượng vùng tài nguyên (WORLD §3.2): Lịch Luyện rút mỗi giờ; dưới ngưỡng sản lượng ×0,5
  RESERVE_DRAIN_PER_H: 15,
  RESERVE_LOW: 20,
  RESERVE_LOW_MULT: 0.5,

  // ── Linh Thực & Luyện Đan (CRAFTING §1–2)
  HERB_BASE_YEARS: 10,
  HERB_YEARS_PER_H: 10,
  HERB_GROWTH_PER_LV: 0.15,
  HERB_AGE_Q: { decade: 0, century: 8, millennium: 18, myriad: 30 },
  HERB_SEED_RETURN: 0.7,
  ALCHEMY_Q_BASE: 35,
  ALCHEMY_Q_PER_LV: 5,
  ALCHEMY_Q_LV_CAP: 25,
  ALCHEMY_ROOM_Q_PER_LV: 2,
  ALCHEMY_LV_CAP_PER_REALM: 2,
  ALCHEMY_XP_BASE: 100,
  ALCHEMY_XP_GROWTH: 1.6,
  ALCHEMY_XP_PER_TIER: 10,
  ALCHEMY_GRADE_XP: { waste: 0.5, low: 1, mid: 1.2, high: 1.5, peak: 2 },
  FIRE_Q: { mortal: 0, earth: 10 },
  HEAT_STEP_OK: 10,
  HEAT_STEP_BAD: -5,
  ALCHEMY_NOISE_SD: 6,
  ALCHEMY_NOISE_CLAMP: 12,
  PILL_GRADE_Q: { low: 35, mid: 60, high: 80, peak: 100 },
  PILL_GRADE_EFFICACY: { low: 0.75, mid: 1.0, high: 1.25, peak: 1.5 },
  PILL_PATTERN_EFFICACY: 0.05,
  PILL_TOXICITY_MAX: 100,
  PILL_TOXICITY_SAFE: 60,
  PILL_TOXICITY_MIN_EFFICACY: 0.3,
  PILL_TOXICITY_DECAY_PER_H: 10,
  PILL_TOXICITY_DECAY_TRIAL_PER_H: 3,
  FURNACE_QUEUE_MAX: 10,
  // Công trình động phủ cấp k (DONG_PHU §3.1): base × 2,2^(k−1) linh thạch, xây 5 × 1,8^(k−1) phút
  BUILDING_COST_GROWTH: 2.2,
  BUILD_MIN_BASE: 5,
  BUILD_MIN_GROWTH: 1.8,
  // Đăng Linh trao trong phiên đầu (CRAFTING §2.6 ghi chú P0)
  GIFT_QI_PILLS: 3,
  GIFT_SPRING_PILLS: 5,

  // Số seed mỗi kịch bản của npm run sim (BALANCE §10.1)
  SIM_SEEDS: 20,
  // Mốc reset ngày (UI_SPEC §15)
  DAY_RESET_HOUR: 5,
} as const;
